module.exports = __webpack_public_path__ + "img/activity.37a02799.png";